exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-toolbar--fixed[data-v-a01410a4] {\n  z-index: 5 !important;\n}\n", ""]);

// exports
